<template lang="html">
    <ul class="main-menu__submenu">
        <li class="main-menu__item has-droprdown">
            <router-link v-bind:to="{ name: 'Operations'}" v-bind:class="activeMenu">
                <md-icon>monetization_on</md-icon>
                <span>Финансы</span>
            </router-link>
        </li>
    </ul>
</template>
<script>
    export default {
        name: 'finance-main-menu',
        sort: 5,
        module: 'finance',
        data() {
            return {
                module: 'finance'
            }
        },
        computed: {
            activeMenu() {
                let routes = ['Operations', 'Operation'];
                return (routes.indexOf(this.$route.name)+1) ? this.$router.options.settingsLinkActiveClass : '';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// MainMenu.vue?b02a775e